var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"evaluation_mains"},[_c('div',{staticClass:"content"},[_c('h6',[_vm._v("请完成以下关于您的"),[_vm._v(_vm._s(_vm.question[_vm.$route.query.question]))]],2),_c('Question',{attrs:{"isSubmit":_vm.isSubmit,"question_data":_vm.question_data,"answered":_vm.answered,"step_idx":_vm.step_idx}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }